var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"viu-button"},[_c('div',{staticClass:"button",class:[
      {
        solid: _vm.fill === 'solid',
        outline: _vm.fill === 'outline',
        medium: _vm.size === 'medium',
        small: _vm.size === 'small',
        row: _vm.size === 'row',
        disabled: _vm.disabled,
        enabled: _vm.enabled,
        'margin-only-text': !_vm.$slots['pre-button'] && !_vm.$slots['post-button'],
        'margin-only-button':
          (_vm.$slots['pre-button'] && !_vm.$slots['text'] && !_vm.$slots['post-button']) ||
          (!_vm.$slots['pre-button'] && !_vm.$slots['text'] && _vm.$slots['post-button'])
      },
      _vm.dusk
    ],attrs:{"disabled":_vm.disabled,"enabled":_vm.enabled},on:{"click":_vm.onClick}},[(_vm.$slots['pre-button'])?_c('div',{staticClass:"pre-button"},[_vm._t("pre-button")],2):_vm._e(),(_vm.$slots['text'])?_c('div',{staticClass:"text"},[_vm._t("text")],2):_vm._e(),(_vm.$slots['post-button'])?_c('div',{staticClass:"post-button"},[_vm._t("post-button")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }